import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.posts.item');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

type DocEditStatus = 'draft' | 'review' | 'ready';
type EditableDocumentField = 'title' | 'summary' | 'sourceLink';

@Component({
    selector: 'wiz-page-posts-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.posts.item/view.scss */
:host {
  display: block;
  min-height: 100vh;
  color: #202733;
  background: #f3f5f8;
  font-family: Inter, "Spoqa Han Sans Neo", "Apple SD Gothic Neo", "Noto Sans KR", sans-serif;
}

.tech-doc-shell {
  min-height: 100vh;
}

.doc-topbar {
  position: sticky;
  top: 0;
  z-index: 20;
  border-bottom: 1px solid #d9dee7;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(8px);
}

.doc-topbar__inner {
  width: min(1240px, 100% - 32px);
  min-height: 58px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
}

.doc-brand {
  color: #147a3b;
  font-size: 18px;
  font-weight: 850;
  letter-spacing: 0;
  text-decoration: none;
}

.doc-nav {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  flex-wrap: wrap;
}

.doc-nav a,
.doc-nav button {
  appearance: none;
  border: 0;
  padding: 7px 10px;
  border-radius: 6px;
  color: #475467;
  background: transparent;
  font: inherit;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.35;
  text-decoration: none;
  cursor: pointer;
}

.doc-nav a:hover,
.doc-nav a:focus-visible,
.doc-nav button:hover,
.doc-nav button:focus-visible {
  color: #166534;
  background: #e8f5ed;
  outline: none;
}

.doc-nav .doc-edit-button {
  border: 1px solid #147a3b;
  color: #166534;
  background: #ffffff;
  font-weight: 850;
}

.doc-nav .doc-edit-button:hover,
.doc-nav .doc-edit-button:focus-visible {
  color: #ffffff;
  background: #147a3b;
}

.doc-page {
  width: min(1240px, 100% - 32px);
  margin: 0 auto;
  padding: 22px 0 42px;
  display: grid;
  grid-template-columns: 220px minmax(0, 1fr);
  gap: 18px;
  align-items: start;
}

.doc-toc,
.doc-infobox {
  position: sticky;
  top: 80px;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
}

.doc-toc {
  padding: 14px;
}

.doc-toc h2,
.doc-infobox h2 {
  margin: 0;
  color: #101828;
  font-size: 15px;
  letter-spacing: 0;
}

.doc-toc ol {
  margin: 10px 0 0;
  padding-left: 0;
  list-style: none;
  display: grid;
  gap: 5px;
}

.doc-toc ol ol {
  margin-top: 5px;
  padding-left: 14px;
  gap: 4px;
}

.doc-toc a {
  display: inline-flex;
  color: #475467;
  font-size: 12px;
  line-height: 1.45;
  text-decoration: none;
}

.doc-toc a:hover,
.doc-toc a:focus-visible {
  color: #147a3b;
  text-decoration: underline;
  outline: none;
}

.doc-article {
  min-width: 0;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
}

.doc-title {
  padding: 28px 30px 22px;
  border-bottom: 1px solid #e4e8ef;
}

.doc-breadcrumb {
  margin: 0 0 8px;
  color: #147a3b;
  font-size: 12px;
  font-weight: 800;
}

.doc-title h1 {
  margin: 0;
  color: #111827;
  font-size: 36px;
  line-height: 1.2;
  letter-spacing: 0;
}

.doc-summary {
  max-width: 760px;
  margin: 14px 0 0;
  color: #475467;
  font-size: 15px;
  line-height: 1.75;
}

.doc-editor-panel {
  box-sizing: border-box;
  padding: 24px 30px;
  border-bottom: 1px solid #e4e8ef;
  background: #f8fafc;
}

.doc-editor-panel * {
  box-sizing: border-box;
}

.doc-editor-panel__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
}

.doc-editor-panel__head span,
.doc-editor-field span {
  color: #147a3b;
  font-size: 12px;
  line-height: 1.35;
  font-weight: 850;
}

.doc-editor-panel__head h2 {
  margin: 4px 0 0;
  color: #111827;
  font-size: 22px;
  line-height: 1.3;
  letter-spacing: 0;
}

.editor-status-toggle {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 6px;
}

.editor-status-toggle button {
  min-height: 32px;
  border: 1px solid #cfd7e3;
  border-radius: 6px;
  padding: 0 10px;
  color: #475467;
  background: #ffffff;
  font: inherit;
  font-size: 12px;
  line-height: 1.35;
  font-weight: 800;
  cursor: pointer;
}

.editor-status-toggle button:hover,
.editor-status-toggle button:focus-visible,
.editor-status-toggle button.is-active {
  border-color: #147a3b;
  color: #ffffff;
  background: #147a3b;
  outline: none;
}

.doc-editor-grid {
  margin-top: 18px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.doc-editor-field {
  min-width: 0;
  display: grid;
  gap: 7px;
}

.doc-editor-field--wide {
  grid-column: span 2;
}

.doc-editor-field input,
.doc-editor-field textarea {
  width: 100%;
  min-width: 0;
  border: 1px solid #cfd7e3;
  border-radius: 6px;
  padding: 10px 12px;
  color: #202733;
  background: #ffffff;
  font: inherit;
  font-size: 13px;
  line-height: 1.55;
  outline: none;
}

.doc-editor-field input:focus,
.doc-editor-field textarea:focus {
  border-color: #147a3b;
  box-shadow: 0 0 0 3px rgba(20, 122, 59, 0.12);
}

.doc-editor-field textarea {
  resize: vertical;
}

.doc-editor-textarea {
  min-height: 280px;
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", monospace;
}

.doc-editor-actions {
  min-width: 0;
  margin-top: 14px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.doc-editor-save {
  min-height: 36px;
  border: 1px solid #147a3b;
  border-radius: 6px;
  padding: 0 14px;
  color: #ffffff;
  background: #147a3b;
  font: inherit;
  font-size: 13px;
  line-height: 1.35;
  font-weight: 850;
  cursor: pointer;
}

.doc-editor-save:hover,
.doc-editor-save:focus-visible {
  background: #166534;
  outline: none;
}

.doc-editor-link {
  min-width: 0;
  color: #166534;
  font-size: 12px;
  line-height: 1.45;
  font-weight: 800;
  text-decoration: none;
  overflow-wrap: anywhere;
}

.doc-editor-link:hover,
.doc-editor-link:focus-visible {
  text-decoration: underline;
  outline: none;
}

.doc-editor-saved {
  color: #475467;
  font-size: 12px;
  line-height: 1.45;
  font-weight: 750;
}

.ref {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  margin: 0 2px;
  padding: 0 3px;
  color: #166534;
  border-radius: 999px;
  cursor: help;
  font-size: 0.82em;
  font-weight: 800;
  line-height: 1.2;
  vertical-align: middle;
}

.ref:focus-visible {
  outline: 2px solid #86efac;
  outline-offset: 2px;
}

.ref::after {
  position: absolute;
  left: 50%;
  bottom: calc(100% + 8px);
  z-index: 20;
  width: max-content;
  max-width: min(320px, 72vw);
  padding: 8px 10px;
  border: 1px solid #bbf7d0;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.14);
  color: #14532d;
  content: attr(data-note);
  font-size: 12px;
  font-weight: 700;
  line-height: 1.45;
  opacity: 0;
  pointer-events: none;
  text-align: center;
  transform: translate(-50%, 4px);
  transition: opacity 0.16s ease, transform 0.16s ease;
  white-space: normal;
}

.ref::before {
  position: absolute;
  left: 50%;
  bottom: calc(100% + 3px);
  z-index: 21;
  width: 8px;
  height: 8px;
  background: #ffffff;
  border-right: 1px solid #bbf7d0;
  border-bottom: 1px solid #bbf7d0;
  content: "";
  opacity: 0;
  pointer-events: none;
  transform: translate(-50%, 4px) rotate(45deg);
  transition: opacity 0.16s ease, transform 0.16s ease;
}

.ref:hover,
.ref:focus-visible {
  background: #ffffff;
}

.ref:hover::after,
.ref:hover::before,
.ref:focus-visible::after,
.ref:focus-visible::before {
  opacity: 1;
  transform: translate(-50%, 0);
}

.ref:hover::before,
.ref:focus-visible::before {
  transform: translate(-50%, 0) rotate(45deg);
}

.wiki-section {
  padding: 24px 30px;
  border-bottom: 1px solid #e4e8ef;
}

.wiki-section:last-child {
  border-bottom: 0;
}

.wiki-section h2 {
  margin: 0 0 14px;
  padding-bottom: 8px;
  border-bottom: 2px solid #d9dee7;
  color: #111827;
  font-size: 24px;
  line-height: 1.3;
  letter-spacing: 0;
}

.wiki-section h3 {
  margin: 22px 0 10px;
  padding-bottom: 6px;
  border-bottom: 1px solid #e4e8ef;
  color: #172033;
  font-size: 18px;
  line-height: 1.35;
  letter-spacing: 0;
}

.section-number {
  margin-right: 8px;
  color: #147a3b;
  font-weight: 850;
}

.wiki-section p {
  margin: 0 0 12px;
  color: #344054;
  font-size: 14px;
  line-height: 1.8;
}

.visual-grid,
.figure-row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  margin: 16px 0 4px;
}

.visual-card {
  min-width: 0;
  margin: 0;
  overflow: hidden;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  background: #fbfcfe;
}

.visual-card--wide {
  grid-column: span 2;
}

.visual-card img {
  display: block;
  width: 100%;
  height: auto;
  background: #ffffff;
  border-bottom: 1px solid #e4e8ef;
}

.visual-card--wide img {
  height: auto;
}

.visual-card figcaption {
  min-height: 44px;
  padding: 10px 12px;
  color: #475467;
  font-size: 12px;
  line-height: 1.55;
  background: #fbfcfe;
}

.doc-table {
  width: 100%;
  margin: 16px 0 6px;
  border-collapse: collapse;
  border: 1px solid #d9dee7;
  font-size: 13px;
}

.doc-table th,
.doc-table td {
  padding: 11px 12px;
  border: 1px solid #d9dee7;
  vertical-align: top;
  text-align: left;
}

.doc-table th {
  color: #172033;
  background: #f1f5f9;
  font-weight: 850;
}

.doc-table td {
  color: #475467;
  background: #ffffff;
}

.code-block {
  margin: 14px 0 4px;
  padding: 14px 16px;
  overflow-x: auto;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  background: #111827;
  color: #e5e7eb;
  font-size: 13px;
  line-height: 1.6;
}

.split-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.split-list > div {
  border: 1px solid #d9dee7;
  border-radius: 8px;
  padding: 14px 16px;
  background: #fbfcfe;
}

.split-list h3 {
  margin: 0 0 10px;
  padding: 0;
  border: 0;
  font-size: 15px;
}

.split-list ul,
.demo-list,
.related-links,
.reference-list {
  margin: 0;
  padding-left: 18px;
  color: #344054;
  font-size: 14px;
  line-height: 1.75;
}

.demo-list {
  margin-top: 10px;
}

.reference-list {
  font-size: 13px;
}

.related-links a,
.reference-list a {
  color: #166534;
  font-weight: 750;
  text-decoration: none;
}

.related-links a:hover,
.related-links a:focus-visible,
.reference-list a:hover,
.reference-list a:focus-visible {
  text-decoration: underline;
  outline: none;
}

.reference-list li:target {
  background: #ecfdf3;
  box-shadow: 0 0 0 3px #ecfdf3;
}

.doc-infobox {
  overflow: hidden;
}

.doc-infobox h2 {
  padding: 14px 16px;
  border-bottom: 1px solid #d9dee7;
  background: #e8f5ed;
  color: #14532d;
}

.doc-infobox dl {
  margin: 0;
}

.doc-infobox dl div {
  display: grid;
  grid-template-columns: 92px minmax(0, 1fr);
  border-bottom: 1px solid #e4e8ef;
}

.doc-infobox dt,
.doc-infobox dd {
  margin: 0;
  padding: 11px 12px;
  font-size: 12px;
  line-height: 1.5;
}

.doc-infobox dt {
  color: #344054;
  background: #f8fafc;
  font-weight: 850;
}

.doc-infobox dd {
  color: #475467;
}

.infobox-link {
  display: flex;
  justify-content: center;
  margin: 12px;
  min-height: 36px;
  align-items: center;
  border: 1px solid #cfd7e3;
  border-radius: 6px;
  color: #166534;
  background: #ffffff;
  font-size: 12px;
  font-weight: 800;
  text-decoration: none;
}

.infobox-link:hover,
.infobox-link:focus-visible {
  background: #f0fdf4;
  outline: none;
}

@media (max-width: 1080px) {
  .doc-page {
    grid-template-columns: 1fr;
  }
  .doc-toc {
    position: static;
  }
}
@media (max-width: 820px) {
  .doc-topbar__inner,
  .doc-page {
    width: min(100% - 24px, 1240px);
  }
  .doc-topbar__inner {
    min-height: auto;
    padding: 12px 0;
    align-items: flex-start;
    flex-direction: column;
  }
  .doc-page {
    grid-template-columns: 1fr;
    padding-top: 14px;
  }
  .doc-title,
  .doc-editor-panel,
  .wiki-section {
    padding-left: 18px;
    padding-right: 18px;
  }
  .doc-editor-panel__head,
  .doc-editor-grid {
    grid-template-columns: 1fr;
  }
  .doc-editor-panel__head {
    display: grid;
  }
  .editor-status-toggle {
    justify-content: flex-start;
  }
  .doc-editor-field--wide {
    grid-column: span 1;
  }
  .doc-title h1 {
    font-size: 30px;
  }
  .wiki-section h2 {
    font-size: 22px;
  }
  .visual-grid,
  .figure-row,
  .split-list,
  .doc-infobox dl div {
    grid-template-columns: 1fr;
  }
  .visual-card--wide {
    grid-column: span 1;
  }
  .doc-infobox dt {
    border-bottom: 1px solid #e4e8ef;
  }
}`],
})
export class PagePostsItemComponent implements OnInit {
    public isEditorOpen = false;
    public editorTitle = '트랜스포머';
    public editorSummary = 'Transformer는 문장 안의 토큰들이 서로를 얼마나 참고해야 하는지 계산하는 self-attention 중심의 딥러닝 아키텍처다.';
    public editorSourceLink = 'https://arxiv.org/abs/1706.03762';
    public editorBody = [
        '# 트랜스포머',
        '',
        '## 1. 개요',
        '트랜스포머는 순환 신경망처럼 토큰을 순서대로 처리하지 않고, 한 번에 전체 토큰 관계를 계산한다.',
        '',
        '## 2. 편집 메모',
        '- 문서 본문은 페이지 안의 에디터에서 직접 수정한다.',
        '- 출처 링크는 보조 초안 생성이나 검수 참고용으로만 사용한다.',
    ].join('\n');
    public editorStatus: DocEditStatus = 'draft';
    public editorSavedAt = '';
    public readonly editorStatuses: Array<{ id: DocEditStatus; label: string }> = [
        { id: 'draft', label: '초안' },
        { id: 'review', label: '검토' },
        { id: 'ready', label: '반영 대기' },
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }

    public get editorLink(): string {
        return '/posts/transformer/view#editor';
    }

    public async toggleEditor() {
        this.isEditorOpen = !this.isEditorOpen;
        await this.service.render();
    }

    public updateEditorField(field: EditableDocumentField, event: Event) {
        const input = event.target as HTMLInputElement | HTMLTextAreaElement;
        const value = input.value || '';

        if (field === 'title') {
            this.editorTitle = value;
        }

        if (field === 'summary') {
            this.editorSummary = value;
        }

        if (field === 'sourceLink') {
            this.editorSourceLink = value;
        }
    }

    public updateEditorBody(event: Event) {
        const input = event.target as HTMLTextAreaElement;
        this.editorBody = input.value || '';
    }

    public async setEditorStatus(status: DocEditStatus) {
        this.editorStatus = status;
        await this.service.render();
    }

    public async saveEditorDraft() {
        this.editorSavedAt = this.formatSavedAt(new Date());
        await this.service.render();
    }

    public trackByEditorStatus(_: number, status: { id: DocEditStatus }) {
        return status.id;
    }

    public scrollToSection(event: MouseEvent, sectionId: string) {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
            return;
        }

        event.preventDefault();

        const target = document.getElementById(sectionId);

        if (!target) {
            return;
        }

        const topbar = document.querySelector('.doc-topbar') as HTMLElement | null;
        const topbarHeight = topbar ? topbar.getBoundingClientRect().height : 0;
        const targetTop = window.scrollY + target.getBoundingClientRect().top - topbarHeight - 16;

        window.scrollTo({
            top: Math.max(0, Math.round(targetTop)),
            behavior: 'smooth',
        });
    }

    private formatSavedAt(value: Date): string {
        const year = value.getFullYear();
        const month = `${value.getMonth() + 1}`.padStart(2, '0');
        const date = `${value.getDate()}`.padStart(2, '0');
        const hours = `${value.getHours()}`.padStart(2, '0');
        const minutes = `${value.getMinutes()}`.padStart(2, '0');

        return `${year}-${month}-${date} ${hours}:${minutes}`;
    }
}

export default PagePostsItemComponent;